module.exports = __webpack_public_path__ + "img/dev.b10ade8c.svg";